/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'
import { useAuth } from '../../../../app/modules/auth'

export function AsideMenuMain() {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
             icon='/media/icons/duotune/general/gen001.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      <AsideMenuItem
        to='/programlist'
        icon='/media/icons/duotune/general/gen025.svg'
        title='Programs'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/courselist'
        icon='/media/icons/duotune/general/gen005.svg'
        title='Courses'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/modulelist'
        icon='/media/icons/duotune/general/gen010.svg'
        title='Modules'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/unitlist'
        icon='/media/icons/duotune/general/gen059.svg'
        title='Units'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/category'
        icon='/media/icons/duotune/general/gen017.svg'
        title='Category'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/videolist'
        icon='/media/icons/duotune/general/gen062.svg'
        title='Videos'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/schedulelist'
        icon='/media/icons/duotune/general/gen014.svg'
        title='Schedule'
        fontIcon='bi-layers'
      />

      {currentUser.role === 'super-admin' && (
        <AsideMenuItem
          to='/subscriptionlist'
          icon='/media/icons/duotune/general/gen003.svg'
          title='Subscriptions'
          fontIcon='bi-layers'
        />
       )}

      {currentUser.role === 'super-admin' && (
        <AsideMenuItem
          to='/userlist'
          icon='/media/icons/duotune/general/gen049.svg'
          title='Users'
          fontIcon='bi-layers'
        />
       )}

       <AsideMenuItem
        to='/announcement-types'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Announcement Types'
        fontIcon='bi-layers'
      /> 

      <AsideMenuItem
        to='/announcementlist'
        icon='/media/icons/duotune/general/gen007.svg'
        title='Announcements'
        fontIcon='bi-layers'
      /> 

      <AsideMenuItem
        to='/faqlist'
        icon='/media/icons/duotune/general/gen016.svg'
        title='FAQs'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/cohortlist'
      icon='/media/icons/duotune/general/gen012.svg'
        title='Cohort'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/languagelist'
        icon='/media/icons/duotune/general/gen009.svg'
        title='Languages'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/settings'
        icon='/media/icons/duotune/general/gen045.svg'
        title='Settings'
        fontIcon='bi-gear'
      />
    </>
  )
}
